import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../utils/Context";
import { v4 as uuidv4 } from "uuid";
import Parse from "parse";
import "./style.css";

//material UI
import Button from "@mui/material/Button";

//icones
import GamePadIcon from "@mui/icons-material/SportsEsports";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import FacebookIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkIcon from "@mui/icons-material/Link";

export default function CustomButton({
  title,
  type,
  width,
  height,
  backcolor,
  upper,
  path,
  correct,
  marginRight,
  desc,
  disabled,
  animation,
}) {
  const {
    count,
    setNumberAnswers,
    setNewQuestion,
    correctAnswer,
    setNewCorrectAnswer,
  } = useContext(Context);
  const navigate = useNavigate();
  Parse.initialize(
    "FCdW0v97ycNx7HNsJhTxsAGJP1Cm5441F2dDt6mn",
    "0A4aIECXyyG7bo3phYAGGNlwsgIwYrDpaaqbD8ou"
  );
  Parse.serverURL = "https://parseapi.back4app.com/";

  const handleClick = (e) => {
    /*console.error(
      "título do botão: " +
        title +
        " #### nº clicks nos botões (inicial): " +
        count +
        " #### é a resposta correta? " +
        correct
    );*/

    //valida se é a 1ª resposta ou se está no intervalo das 5 permitidas
    if (correct !== undefined && count <= 5) {
      setNumberAnswers(count + 1);
      /*console.warn(
        "Foi adicionada mais uma resposta... (nº atual: " + count + ")"
      );*/
    }

    //valida se acertei na resposta correta
    if (correct !== undefined && correct === "true") {
      setNewCorrectAnswer(correctAnswer + 1);
      /*console.warn(
        "A resposta está correta! (nº de respostas certas: " +
          correctAnswer +
          ")"
      );*/
    }

    //console.log(count + " <--> " + correctAnswer);
    if (count === 6 && correctAnswer >= 3) {
      /*console.log(
        "O utilizador ganhou!!!! (respostas CORRETAS: " + correctAnswer + ")"
      );*/
      sendVictoryData(count, correctAnswer);

      setNumberAnswers(1);
      setNewQuestion([]);
      setNewCorrectAnswer(1);
      navigate("/win");
    } else if (count === 6 && correctAnswer <= 2) {
      /*console.log(
        "O utilizador perdeu!!!!(respostas CORRETAS: " + correctAnswer + ")"
      );*/
      setNumberAnswers(1);
      setNewQuestion([]);
      setNewCorrectAnswer(1);
      navigate("/lost");
    } else if (path !== undefined) {
      navigate("/" + path);
      //window.location.replace(path);
    }
  };

  const statusIcon = (status) => {
    switch (status) {
      case "GamePadIcon":
        return <GamePadIcon style={{ color: "#000000" }} />;
      case "CheckCircleIcon":
        return <CheckCircleIcon style={{ color: "green" }} />;
      case "ClearIcon":
        return <ClearIcon style={{ color: "#FF0000" }} />;
      case "RefreshIcon":
        return (
          <RefreshIcon
            style={{
              color: "#000000",
              width: "100%",
              height: "auto",
              transform: "scaleX(-1)",
            }}
          />
        );
      case "Instagram":
        return <InstagramIcon style={{ color: "#000000" }} />;
      case "Facebook":
        return <FacebookIcon style={{ color: "#000000" }} />;
      case "Twitter":
        return <TwitterIcon style={{ color: "#000000" }} />;
      case "Link":
        return <LinkIcon style={{ color: "#000000" }} />;
      default:
        return;
    }
  };

  const sendVictoryData = (count, correctAnswer) => {
    const Quiz = Parse.Object.extend("Quiz");
    const quizData = new Quiz();
    console.log("@@@@ " + count + " ----- " + correctAnswer);

    quizData.set("deviceId", uuidv4());
    quizData.set("totalNumberOfQuestions", count);
    quizData.set("numberOfCorrectAnswers", correctAnswer);
    quizData.set("numberOfWrongAnswers", count - correctAnswer);

    quizData.save().then(
      (result) => {
        console.log("Quiz data sent successfully:", result);
      },
      (error) => {
        console.error("Error sending quiz data:", error);
      }
    );
  };

  return (
    <>
      <Button
        variant="outlined"
        endIcon={statusIcon(type)}
        sx={{
          width: { width },
          height: { height },
          color: "#000000",
          borderColor: "#000000",
          borderWidth: "thick",
          borderRadius: "57px",
          backgroundColor: backcolor ? "#EDE838" : "transparent",
          marginRight: marginRight ? marginRight : 0,
          animation: animation ? animation : "",
          fontSize: "1.25em",
          fontWeight: "700",
          fontFamily: "Inter, Helvetica, sans-serif",
          lineHeight: "1.25em",
          textTransform: upper ? "uppercase" : "none",
          "& .MuiButton-endIcon": {
            margin: "0",
          },
        }}
        correct={correct}
        onClick={handleClick}
        aria-label={desc}
        disabled={disabled ? true : false}
      >
        {title}
      </Button>
    </>
  );
}
